import { render, staticRenderFns } from "./PrfViewqr.vue?vue&type=template&id=c83fb094"
import script from "./PrfViewqr.vue?vue&type=script&lang=js"
export * from "./PrfViewqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports